export default __webpack_public_path__ + "d4bb683ebc902df9b385e52693ff0c05.png";